import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-green-900 text-white py-6 mt-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4 gap-4">
        <div className="flex items-center gap-2">
          <span className="font-bold text-lg">DivineWellness</span>
        </div>
        <div className="flex gap-6 mb-2 md:mb-0">
          <Link to="/" className="hover:underline">Home</Link>
          <Link to="/about" className="hover:underline">About Us</Link>
          <Link to="/contact" className="hover:underline">Contact Us</Link>
          <Link to="/appointment" className="hover:underline">Appointment</Link>
          <Link to="/gallery" className="hover:underline">Gallery</Link>
        </div>
        <div className="flex gap-4">
          <a href="#" aria-label="Facebook"><FaFacebook size={20} /></a>
          <a href="#" aria-label="Instagram"><FaInstagram size={20} /></a>
          <a href="#" aria-label="WhatsApp"><FaWhatsapp size={20} /></a>
        </div>
      </div>
      <div className="text-center text-sm mt-4">&copy; {new Date().getFullYear()} DivineWellness. All rights reserved.</div>
    </footer>
  );
}

export default Footer;
